import { notifications } from '@mantine/notifications';
import { getCruisesKey, useCreateCruise } from 'api-hooks/cruise';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import CruiseForm from './components/form';

export default function CruiseCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreateCruise();
  const permission = useGetCrudPermission('cruises');

  return (
    <CruiseForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);

        queryClient.refetchQueries([getCruisesKey()[0]]);

        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.CruisesView, {
            id: result.data?.id,
          });
        }

        notifications.show({ message: result?.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
